import { useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from './redux'
import { setNavigate } from '../redux/slice/user'

type PathT = { name: string; url: string; [key: string]: any }

const useChangeRoutPath = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const urls = useAppSelector((state) => state.user.navigate)
  const dispatch = useAppDispatch()

  const replaceLastPath = (path: PathT) => {
    const pathNow = location.pathname.split('/').slice(0, -1).join('/')
    const newUrls = [...urls.slice(0, -1), path]
    dispatch(setNavigate(newUrls))
    navigate(pathNow + '/' + path.url)
  }

  const addRouteInPath = (path: PathT | PathT[]) => {
    if (Array.isArray(path)) {
      let urlString = ''
      const newUrls = [...urls, ...path]
      newUrls.forEach(({ url }) => (urlString += '/' + url))
      dispatch(setNavigate(newUrls))
      navigate(urlString)
      return
    }
    const pathNow = location.pathname
    const newUrls = [...urls, path]
    dispatch(setNavigate(newUrls))
    navigate(pathNow + '/' + path.url)
  }

  const navigateTo = (path: PathT | PathT[]) => {
    if (Array.isArray(path)) {
      let urlString = ''
      const newUrls = path.map((item) => {
        urlString = urlString + '/' + item.url
        return item
      })
      dispatch(setNavigate(newUrls))
      navigate(urlString)
      return
    }

    const userNavigateIndex = urls.indexOf(path)
    if (userNavigateIndex !== -1) {
      const newUrl = urls.slice(0, userNavigateIndex + 1)
      dispatch(setNavigate(newUrl))
      navigate(newUrl.map(({ url }) => url).join('/'))
    } else {
      dispatch(setNavigate(path))
    }
  }

  const navigateAfterDomain = (path: PathT[]) => {
    const dom = urls.slice(0, 1)

    navigateTo([...dom, ...path])
  }

  const connectTo = (path: PathT) => {
    const newUrls = [...urls]
    const [fist, second, third, ...other] = newUrls

    navigateTo([fist, path, third])
  }

  return {
    addRouteInPath,
    replaceLastPath,
    navigateTo,
    connectTo,
    navigateAfterDomain,
  }
}

export default useChangeRoutPath
